import React from "react";

import { VideoViewBase } from "../VideoViewBase";

import { LocalVideo } from "./LocalVideo";
import { RemoteVideo } from "./RemoteVideo";

import "./Steps.styles.scss";

export function PatientInRoomStep(props) {
  const content = (
    <>
      <div className="GuidedVideoCall__whole_screen_view">
        <RemoteVideo {...props} fullscreenMode={true} />
        <LocalVideo {...props} />
      </div>
    </>
  );

  return <VideoViewBase content={content} {...props} />;
}
